import { CoralogixRum } from '@coralogix/browser'

export function initCoralogix() {
  CoralogixRum.init({
    public_key: process.env.NEXT_PUBLIC_CORALOGIX_RUM_PUBLIC_KEY!,
    application: 'classy-checkout',
    environment: process.env.APP_ENV,
    version: '1.0.4',
    coralogixDomain: 'US2',
    debug: process.env.NODE_ENV === 'development',
    supportMfe: false,
    traceParentInHeader: {
      enabled: true,
    },
    memoryUsageConfig: {
      enabled: true,
      interval: 300_000,
    },
  })
}
